import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import logo from 'aurora-images/adgm-logo.svg';
import instaIcon from 'aurora-images/insta.svg';
import linkedInIcon from 'aurora-images/linkedIn.svg';
import playStoreIcon from 'aurora-images/googleplayStore.svg';
import appStoreIcon from 'aurora-images/Download_on_the_App_Store.svg';
import fbIcon from 'aurora-images/fb.svg';
import classNames from 'classnames';
import styles from './style';

const PaymentEmail = props => {
  const { classes } = props;
  useEffect(() => {
    console.log('inside email template');
  }, []);
  return (
    <>
      <div className={classes.container}>
        <header className={classes.header}>
          <img src={logo} alt='logo' />
        </header>
        <hr className={classes.hr} />
        <main className={classes.main}>
          <div>
            <div>Dear customer,</div>
            <div>This email confirms your payment for the transaction ID____</div>
          </div>
          <div className={classes.heading}>Payment Invoice for “Service name”</div>
          <div>
            <div className={classes.styledTextContainer}>
              <div>Application number</div>
              <div>8736246234</div>
            </div>
            <div className={classes.styledTextContainer}>
              <div>Transaction ID</div>
              <div>90328743</div>
            </div>
          </div>
          <div className={classes.boxDiv}>
            <div className={classes.boxDivContent}>
              <div>Municipality service charges</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 300</div>
              <div>رسوم الخدمات البلدية</div>
            </div>
            <div className={classes.boxDivContent}>
              <div>VAT 5%</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 30</div>
              <div>ضريبة القيمة المضافة 5%</div>
            </div>
            <hr className={classes.boxHr1} />
            <div className={classes.boxDivContent}>
              <div>Electronic administrative services allowance</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 50</div>
              <div>رسوم الخدمات البلدية</div>
            </div>
            <div className={classes.boxDivContent}>
              <div>VAT 5%</div>
              <div className={classNames(classes.Price, classes.fontW500)}>AED 30</div>
              <div>ضريبة القيمة المضافة 5%</div>
            </div>
            <hr className={classes.boxHr2} />
            <div className={classes.boxDivContent}>
              <div className={classes.fontW500}>Total amount (Including VAT)</div>
              <div className={classNames(classes.Price, classes.fontW600)}>AED 382.50</div>
              <div className={classes.fontW700}>المبلغ الإجمالي (بما في ذلك ضريبة القيمة المضافة)</div>
            </div>
          </div>
        </main>
        <footer className={classes.footer}>
          <hr className={classes.hr} />
          <div className={classes.footerDiv}>
            <div className={classes.socialDiv}>
              <div>
                <a href='#' target='_blank'>
                  <img src={logo} alt='logo' />
                </a>
              </div>
              <div>
                <a href='accessrp.adgm.com' target='_blank'>
                  accessrp.adgm.com
                </a>
              </div>
              <div>
                <a href='#' target='_blank'>
                  <img src={instaIcon} alt='insta' />
                </a>
                <a href='#' target='_blank'>
                  <img src={fbIcon} alt='fb' />
                </a>
                <a href='#' target='_blank'>
                  <img src={linkedInIcon} alt='linkedIn' />
                </a>
              </div>
            </div>
            <div className={classes.playstoreDiv}>
              <a href='#' target='_blank'>
                <img src={appStoreIcon} alt='app_store' />
              </a>
              <a href='#' target='_blank'>
                <img src={playStoreIcon} alt='play_store' />
              </a>
            </div>
          </div>
          <div className={classes.addressDiv}>
            <span>ADRES</span>
            <span>Al Dar Hq, Abu Dhabi, UAE</span>
            <span>600523333</span>
            <span>Support@accessrp.adgm.com</span>
          </div>
        </footer>
      </div>
    </>
  );
};

PaymentEmail.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaymentEmail);
